module.exports = __webpack_public_path__ + "img/HA1504-167.8d4a95d7.jpg";